export default __webpack_public_path__ + "static/media/culture_EP19.bc75a349.png";